// Open the variant drawer for colour range
function openVariantDrawer() {
  const overlay = document.getElementById("variant-drawer-overlay");
  const drawer = document.getElementById("variant-drawer-colour-range");
  if (overlay && drawer) {
    document.body.classList.add("body-scroll-lock");
    overlay.style.display = "block";
    drawer.style.display = "flex";
    drawer.style.right = "-100%"; // Start off-screen
    drawer.style.transition = "none"; // Disable transition initially
    setTimeout(() => {
      drawer.style.transition = "right 0.2s ease-in-out";
      drawer.style.right = "0";
      overlay.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
    }, 10);
  }
}

// Scroll drawer body to top
function scrollDrawerToTop(drawerId) {
  const drawer = document.getElementById(drawerId);
  if (drawer) {
    const body = drawer.querySelector('.product-drawer__body');
    if (body) {
      body.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
}

// AJAX load the variant-select drawers section for colour swatches
document.addEventListener("DOMContentLoaded", function () {
  const overlay = document.getElementById("variant-drawer-overlay");
  const colourDrawer = document.getElementById("variant-drawer-colour");
  const contentContainer = colourDrawer.querySelector(".product-drawer__content-container");

  document.querySelectorAll(".linked-product-swatch").forEach(function (swatch) {
    swatch.addEventListener("click", function (e) {
      e.preventDefault();
      const handle = swatch.getAttribute("data-product-handle");
      if (!handle) return;

      // Show loading state
      contentContainer.innerHTML = "<div style='padding:2em;text-align:center;'>Loading...</div>";

      // Fetch the product's variant-drawers section
      fetch(`/products/${handle}?section_id=variant-drawers`)
        .then(res => res.text())
        .then(html => {
          console.log(html); 
          const tempDiv = document.createElement("div");
          tempDiv.innerHTML = html;
          const picker = tempDiv.querySelector("variant-selects");
          const noscript = tempDiv.querySelector("noscript");
          contentContainer.innerHTML = "";
          if (picker) contentContainer.appendChild(picker);
          if (noscript) contentContainer.appendChild(noscript);
          if (!picker) {
            contentContainer.innerHTML = "<div style='padding:2em;text-align:center;'>Could not load variant picker.</div>";
          }
          openColourDrawer();
        })
        .catch(() => {
          contentContainer.innerHTML = "<div style='padding:2em;text-align:center;'>Error loading product.</div>";
          openColourDrawer();
        });
    });
  });

  function openColourDrawer() {
    overlay.style.display = "block";
    colourDrawer.style.display = "flex";
    colourDrawer.style.right = "-100%"; // Start off-screen
    colourDrawer.style.transition = "none"; // Disable transition initially
    setTimeout(() => {
      colourDrawer.style.transition = "right 0.2s ease-in-out";
      colourDrawer.style.right = "0";
      overlay.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
    }, 10);
  }
});

// Close logic for overlay and close buttons
document.addEventListener("DOMContentLoaded", function () {
  const overlay = document.getElementById("variant-drawer-overlay");
  const drawers = [
    document.getElementById("variant-drawer-colour-range"),
    document.getElementById("variant-drawer-colour")
  ];
  const closeButtons = document.querySelectorAll(".drawer__close");

  closeButtons.forEach(function (closeBtn) {
    closeBtn.addEventListener("click", function () {
      drawers.forEach(function (drawer) {
        if (drawer && drawer.style.display === "flex") {
          drawer.style.transition = "right 0.2s ease-in-out";
          drawer.style.right = "-100%";
        }
      });
      overlay.style.backgroundColor = "rgba(0, 0, 0, 0)";
      setTimeout(() => {
        drawers.forEach(function (drawer) {
          if (drawer) drawer.style.display = "none";
        });
        overlay.style.display = "none";
        document.body.classList.remove("body-scroll-lock");
      }, 200);
    });
  });

  if (overlay) {
    overlay.addEventListener("click", function () {
      drawers.forEach(function (drawer) {
        if (drawer && drawer.style.display === "flex") {
          drawer.style.transition = "right 0.2s ease-in-out";
          drawer.style.right = "-100%";
        }
      });
      overlay.style.backgroundColor = "rgba(0, 0, 0, 0)";
      setTimeout(() => {
        drawers.forEach(function (drawer) {
          if (drawer) drawer.style.display = "none";
        });
        overlay.style.display = "none";
        document.body.classList.remove("body-scroll-lock");
      }, 200);
    });
  }
});
// Back button for the variant drawer
document.addEventListener("DOMContentLoaded", function () {
  const backButton = document.getElementById("variant-colour-drawer-close");
  if (backButton) {
    backButton.addEventListener("click", function () {
      const colourDrawer = document.getElementById("variant-drawer-colour");
      if (colourDrawer && colourDrawer.style.display === "flex") {
        colourDrawer.style.transition = "right 0.2s ease-in-out";
        colourDrawer.style.right = "-100%";
        setTimeout(() => {
          colourDrawer.style.display = "none";
        }, 200);
      }
    });
  }
});